module.exports = __webpack_public_path__ + "img/hiw_horizontal.svg";